import { Routes, Route, Navigate } from 'react-router-dom';
import { useEffect, useState } from 'react';
import { onAuthChange } from '../firebase/auth';
import useAdminAuth from '../hooks/useAdminAuth';

import AdminLogin     from './AdminLogin';
import AdminSidebar   from './AdminSidebar';
import AdminDashboard from './AdminDashboard';

import GlobalEditor     from './editors/GlobalEditor';
import NavEditor        from './editors/NavEditor';
import HeroEditor       from './editors/HeroEditor';
import BenefitsEditor   from './editors/BenefitsEditor';
import HowItWorksEditor from './editors/HowItWorksEditor';
import FeaturesEditor   from './editors/FeaturesEditor';
import IndustriesEditor from './editors/IndustriesEditor';
import PricingEditor    from './editors/PricingEditor';
import FAQEditor        from './editors/FAQEditor';
import ContactEditor    from './editors/ContactEditor';
import FooterEditor        from './editors/FooterEditor';
import SubmissionsViewer  from './editors/SubmissionsViewer';

function AdminShell() {
  useAdminAuth();

  /* Hide the public chat widget inside the admin panel */
  useEffect(() => {
    const widget = document.querySelector('ai-portal-widget');
    const script = document.querySelector('script[src*="ai-portal-chat"]');
    if (widget) widget.style.display = 'none';
    if (script) script.setAttribute('data-paused', 'true');
    return () => {
      if (widget) widget.style.display = '';
    };
  }, []);

  return (
    <div className="adm-layout">
      <AdminSidebar />
      <main className="adm-main">
        <Routes>
          <Route index            element={<AdminDashboard />} />
          <Route path="global"    element={<GlobalEditor />} />
          <Route path="navigation" element={<NavEditor />} />
          <Route path="hero"      element={<HeroEditor />} />
          <Route path="benefits"  element={<BenefitsEditor />} />
          <Route path="howitworks" element={<HowItWorksEditor />} />
          <Route path="features"  element={<FeaturesEditor />} />
          <Route path="industries" element={<IndustriesEditor />} />
          <Route path="pricing"   element={<PricingEditor />} />
          <Route path="faq"       element={<FAQEditor />} />
          <Route path="contact"   element={<ContactEditor />} />
          <Route path="footer"       element={<FooterEditor />} />
          <Route path="submissions"  element={<SubmissionsViewer />} />
          <Route path="*"         element={<Navigate to="/admin" replace />} />
        </Routes>
      </main>
    </div>
  );
}

export default function AdminApp() {
  const [user, setUser]       = useState(undefined);

  useEffect(() => {
    const unsub = onAuthChange(u => setUser(u));
    return unsub;
  }, []);

  if (user === undefined) {
    return <div className="adm-loading">Loading…</div>;
  }

  if (!user) {
    return <AdminLogin />;
  }

  return <AdminShell />;
}
